module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.adminVisible) ? _c('el-dialog', {
    staticClass: "model-edit",
    attrs: {
      "title": "相关订单",
      "width": "950px",
      "visible": _vm.adminVisible,
      "close-on-click-modal": false,
      "before-close": _vm.adminVisibleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.adminVisible = $event
      }
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.userLoading),
      expression: "userLoading"
    }],
    ref: "userList",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "row-key": function (row) { return row.id; },
      "data": _vm.adminList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "产品名称",
      "min-width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "purchaseMonth",
      "label": "购买时长(月)",
      "min-width": "100",
      "xshow-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "purchaseNum",
      "label": "购买数量",
      "min-width": "120",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "singlePrice",
      "label": "单价(元)",
      "min-width": "160",
      "show-overflow-tooltip": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53d17496"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/administrator/authorizeList/detail.vue
// module id = 1740
// module chunks = 9